import { ILeanProductTile } from "@faire/web-api--source/indigofair/data/ILeanProductTile";

import {
  IOnProductClickBase,
  useOnProductClickBase,
} from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/productTileActions/useOnProductClickBase";
import { useBrandProductResultData } from "@faire/retailer/views/brand/hooks/useBrandProductResultData";

interface ProducClickForBrandPageParameters extends IOnProductClickBase {
  showVerticalImagery?: boolean;
}

export const productClickForBrandPageParametersILeanProductTileAdapter = (
  productTile: ILeanProductTile | undefined
): ProducClickForBrandPageParameters => {
  return {
    token: productTile?.product?.token,
    bestImage: productTile?.best_image,
    images: productTile?.images,
    impressionId: productTile?.product?.impression_id ?? "",
  };
};

export const useOnProductClickForBrandPage = (
  params: ProducClickForBrandPageParameters
) => {
  const productsQueryData = useBrandProductResultData();
  const { showVerticalImagery } = productsQueryData ?? {};

  const onProductClick = useOnProductClickBase({
    ...params,
    showVerticalImagery,
  });
  return onProductClick;
};
